export enum TravelCoverType {
    ANNUAL_MULTI_TRIP = "Annual Multi-trip",
    SINGLE_TRIP = "Single Trip"
    
}